import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 10.2 10.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10.2 10.2\" id=\"icon-close\">\n<path d=\"M0,1.3L1.3,0l8.8,8.8l-1.3,1.3L0,1.3z M1.3,10.2L0,8.8L8.8,0l1.3,1.3L1.3,10.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/close.svg
// module id = 120
// module chunks = 0 1 2